// wi_6b5960f9-952c-48fc-ab25-68e9f9e5b2da: the selected player, in sidebar order.
import { isDead } from './scene3d';

const byName = (a, b) => (a.playerName || '')
  .localeCompare(b.playerName || '', undefined, { sensitivity: 'base' });
const aliveSide = (team) => (team?.players ?? []).filter((player) => !isDead(player)).sort(byName);

// Alive CT first, then alive T, each alphabetical, as ViewerSidebar lists them.
export const alivePlayers = (frame) => [...aliveSide(frame?.ct), ...aliveSide(frame?.t)];

// `]` is step 1, `[` is step -1. Wraps around; with nothing selected it starts at an end.
export function cyclePlayer(frame, selectedSteamID, step) {
  const players = alivePlayers(frame);
  if (!players.length) return selectedSteamID;
  const index = players.findIndex((player) => player.steamID === selectedSteamID);
  if (index < 0) return players[step > 0 ? 0 : players.length - 1].steamID;
  return players[(index + step + players.length) % players.length].steamID;
}
